import { Form, InputNumber, Skeleton } from "antd";
import React from "react";

import { Col, CurrentValue, SeriesLabel, SeriesRow } from "../styles";
import { DefaultSerie, SaleChannel } from "../types";

const renderCurrent = (value?: number, loading?: boolean) => {
  if (value != null) {
    return <CurrentValue $empty={false}>{value}</CurrentValue>;
  }
  if (loading) {
    return <Skeleton.Input active size="small" />;
  }
  return <CurrentValue $empty={true}>—</CurrentValue>;
};

interface ChannelRowProps {
  channel: SaleChannel;
  current?: DefaultSerie;
  changed: boolean;
  sequenceDisabled: boolean;
  defaultSerieValue?: number;
  loading?: boolean;
}

const ChannelRow: React.FC<ChannelRowProps> = ({
  channel,
  current,
  changed,
  sequenceDisabled,
  defaultSerieValue,
  loading,
}) => (
  <SeriesRow $changed={changed} align="middle" gutter={16}>
    <Col span={4}>
      <SeriesLabel>{channel.name}</SeriesLabel>
    </Col>

    <Col span={5}>{renderCurrent(current?.serie, loading)}</Col>

    <Col span={5}>{renderCurrent(current?.invoiceSequence, loading)}</Col>

    <Col span={5}>
      <Form.Item
        name={[channel.id, "serie"]}
        rules={[{ type: "number", min: 1, message: "Inválido" }]}
      >
        <InputNumber min={1} precision={0} />
      </Form.Item>
    </Col>

    <Col span={5}>
      <Form.Item
        name={[channel.id, "invoiceSequence"]}
        rules={[
          ({ getFieldValue }) => ({
            validator(_, value) {
              const serie = getFieldValue([channel.id, "serie"]);
              const enabled = serie != null && serie !== defaultSerieValue;
              if (enabled && value == null) {
                return Promise.reject(new Error("Obrigatório"));
              }
              return Promise.resolve();
            },
          }),
        ]}
      >
        <InputNumber
          min={1}
          precision={0}
          disabled={sequenceDisabled}
          placeholder={sequenceDisabled ? "—" : ""}
        />
      </Form.Item>
    </Col>
  </SeriesRow>
);

export default ChannelRow;
